import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentEmptyState = ({
  emptyStateProps,
  emptyStateProps: {
    emptyStateType
  },
  CustomEmptyState
}) => {
  const dataTestId = `empty-state-${emptyStateType}`;
  if (CustomEmptyState) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(CustomEmptyState, Object.assign({}, emptyStateProps))
    });
  }
  const emptyStateMsgKey = emptyStateType || 'default';
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "EMPTY_STATE_LOAD",
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `content-management-listing-lib.emptyStates.default.${emptyStateMsgKey}`
      })
    })
  });
};
export default ContentEmptyState;